import AIIcon from "Assets/Icons/AIIcon";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
import Typography from "Components/CommonComponents/Typography";
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import {
  BASE_URL,
  POST_INSIGHT_FEEDBACK,
} from "utilFunctions/Constants/urlConstants";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import ThumbsDownIcon from "Assets/Icons/ThumbsDownIcon";
import ThumbsUpIcon from "Assets/Icons/ThumbsUpIcon";
import "./index.css";
import { putPostRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import putPostRequestInterface from "utilFunctions/Axios/putPostRequestInterface";
import DraggableModal from "utilFunctions/shared/DraggableModal";
import { Typography as TYantd } from "antd";
import CopyIcon from "Assets/Icons/CopyIcon";
const { Paragraph } = TYantd;
const reasonDeatils: any = [
  {
    id: 1,
    text: "Insight does not match the performance",
  },
  {
    id: 2,
    text: "Disagree with the insights",
  },
  {
    id: 3,
    text: "Insights are not useful at all",
  },
  {
    id: 4,
    text: "Insights are not relevant",
  },
  {
    id: 5,
    text: "Something else",
  },
];
interface IStudentinsightList {
  studentpsid?: any;
  studentInsight?: any;
  studentInsightLoading?: boolean | undefined;
  studentInsightError?: string | undefined;
  handleGenerateinsights?: any;
  viewAllComments?: any;
  setViewAllComments?: any;
}
function StudentInsightListing({
  studentpsid,
  studentInsight,
  studentInsightLoading,
  studentInsightError,
  handleGenerateinsights,
  viewAllComments,
  setViewAllComments,
}: IStudentinsightList) {
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { screen }: any = useWindowSize();
  const [selectedReason, setSelectedreason] = useState<any>();
  const [showPopover, setShowPopover] = useState<boolean | undefined>(false);
  const [showPopoverFeedback, setShowPopoverFeedback] = useState<
    boolean | undefined
  >(false);
  const [feedbackType, setFeedbackType] = useState<string | undefined>();
  const [isComplete, setIsComplete] = useState(false);
  useEffect(() => {
    if (studentInsight && typeof studentInsight.persisted === "boolean") {
      setIsComplete(studentInsight.persisted);
    }
  }, [studentInsight]);
  useLayoutEffect(() => {
    const insightObjectString = localStorage.getItem("insightObject");
    const storageInsightObject = insightObjectString
      ? JSON.parse(insightObjectString)
      : null;
    if (storageInsightObject && Array.isArray(storageInsightObject)) {
      const filteredObject = storageInsightObject.filter(
        (elm: any) => elm.studentPSID == studentpsid
      );
      if (
        filteredObject &&
        filteredObject.length &&
        filteredObject[0]["feedbackType"] != undefined
      ) {
        setFeedbackType(filteredObject[0]["feedbackType"]);
      }
    }
  }, [studentpsid]);
  const postInsightLikeData = async (url: string, obj: any) => {
    putPostRequest({
      url: url,
      success: () => {
        setShowPopoverFeedback(!showPopoverFeedback);
        if (obj.feedback == true) {
          setFeedbackType("liked");
        } else {
          setFeedbackType("disliked");
        }
        const insightObjectString = localStorage.getItem("insightObject");
        const storageInsightObject = insightObjectString
          ? JSON.parse(insightObjectString)
          : null;
        if (storageInsightObject && Array.isArray(storageInsightObject)) {
          const newInsightsObjectArray = storageInsightObject.map(
            (elm: any) => {
              if (elm.studentPSID === studentpsid) {
                return {
                  ...elm,
                  feedbackType: obj.feedback == true ? "liked" : "disliked",
                };
              }
              return elm;
            }
          );
          localStorage.setItem(
            "insightObject",
            JSON.stringify(newInsightsObjectArray)
          );
        }
      },
      failure: (err: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err.message,
        });
      },
      body: obj,
      method: "POST",
    } as putPostRequestInterface);
  };

  const handleInsightLike = () => {
    pushToDataLayerForGTM({
      event: "ag_sp_rate_student_insights",
      PSID: String(studentpsid),
      INSIGHTS_RATING: "positive",
      NEGATIVE_FEEDBACK_REASON: null,
    });
    const insightObj = {
      psid: studentpsid,
      reason: null,
      promptId: studentInsight.promptId,
      insights: null,
      facultyId: userInfo.facId,
      feedback: true,
    };
    setTimeout(() => {
      postInsightLikeData(BASE_URL + POST_INSIGHT_FEEDBACK, insightObj);
    }, 10);
  };
  const handleInsightDislike = () => {
    setShowPopover(true);
  };
  const handleSendDislikeinsight = (reason: any) => {
    pushToDataLayerForGTM({
      event: "ag_sp_rate_student_insights",
      PSID: String(studentpsid),
      INSIGHTS_RATING: "negative",
      NEGATIVE_FEEDBACK_REASON: reason,
    });
    const insightObj = {
      psid: studentpsid,
      reason: parseInt(reason),
      promptId: studentInsight.promptId,
      insights: studentInsight["studentInsights"],
      facultyId: userInfo.facId,
      feedback: false,
    };
    setTimeout(() => {
      postInsightLikeData(BASE_URL + POST_INSIGHT_FEEDBACK, insightObj);
    }, 10);
    setShowPopover(false);
  };
  const handleSelectedReasonOnDiv = (e: any, el: any) => {
    setSelectedreason(el.id);
  };
  const handleSelectedReason = (e: any) => {
    setSelectedreason(e.target.value);
  };
  const closeModal = () => {
    setShowPopover(!showPopover);
    ToastDispatch({
      isOpen: true,
      type: "Info",
      message: "Feedback not taken",
    });
  };
  // const closeModalFeedback = () => {
  //   setShowPopoverFeedback(!showPopoverFeedback);
  // };
  const modalBody = (reasonDeatils: any) => {
    return (
      <div className="d-flex flex-column">
        <div className="w-100">
          {reasonDeatils.map((el: any, index: number) => {
            return (
              <div
                className="radio-button-package-selection"
                key={index}
                onClick={(e: any) => {
                  handleSelectedReasonOnDiv(e, el);
                }}
              >
                <Label className="label-package-selection form-check-input-engagement">
                  {el.text}
                </Label>
                <Input
                  name="package"
                  type="radio"
                  className="form-check-input-engagement"
                  value={el.id}
                  checked={selectedReason == el.id}
                  onChange={(e: any) => {
                    handleSelectedReason(e);
                  }}
                />{" "}
              </div>
            );
          })}
        </div>
        <div className="p-3 pt-4 w-100 d-flex flex-row justify-content-center">
          <Button
            className="btn-width-package-selection"
            disabled={
              selectedReason != undefined && selectedReason != null
                ? false
                : true
            }
            color={
              selectedReason != undefined && selectedReason != null
                ? "aeslPrimary"
                : "aeslDraft"
            }
            onClick={() => {
              handleSendDislikeinsight(selectedReason);
              setShowPopover(!showPopover);
            }}
          >
            Submit
          </Button>
        </div>
      </div>
    );
  };
  return (
    <>
      {/* <Modal
        isOpen={showPopoverFeedback}
        centered={true}
        backdrop={true}
        size={"md"}
        fullscreen={false}
        toggle={closeModalFeedback}
        contentClassName={"insight-modal-style"}
      >
        <ModalHeader toggle={closeModalFeedback}></ModalHeader>
        <ModalBody>
          <div className="w-100 d-flex flex-column justify-content-center align-items-center pt-0 pl-3 pr-3 pb-4 gap-3">
            <SuccessFeedback />
            <div className="w-100 d-flex flex-column justify-content-center align-items-center gap-2">
              <span
                style={{
                  color: "#07794C",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                {"Thank You"}
              </span>
              <span
                style={{
                  color: "#262626",
                  fontSize: " 14px",
                  fontWeight: "400",
                  textAlign: "center",
                }}
              >
                {
                  "Your feedback has been taken and will help in improving AI summary"
                }
              </span>
            </div>
          </div>
        </ModalBody>
      </Modal> */}
      {["xxl", "xl", "lg"].includes(screen) ? (
        <Modal
          isOpen={showPopover}
          centered={true}
          backdrop={true}
          size={"md"}
          fullscreen={false}
          toggle={closeModal}
          contentClassName={"insight-modal-style"}
        >
          <ModalHeader toggle={closeModal}>
            <div className="d-flex flex-column justify-content-center align-items-start gap-2">
              <span
                style={{
                  color: "#333",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                {"Please let us know your feedback"}
              </span>
              <span
                style={{
                  color: "#757575",
                  fontSize: " 12px",
                  fontWeight: "400",
                }}
              >
                {
                  "Please select a reason from below. It will help us improve AI summary"
                }
              </span>
            </div>
          </ModalHeader>
          <ModalBody>{modalBody(reasonDeatils)}</ModalBody>
        </Modal>
      ) : (
        <DraggableModal
          initHeight={"fit-content"}
          isPaneOpen={showPopover}
          togglePane={closeModal}
          onClose={() => {
            console.log("");
          }}
        >
          <div className="d-flex flex-column p-3 justify-content-center align-items-start gap-2">
            <span
              style={{
                color: "#333",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              {"Please let us know your feedback"}
            </span>
            <span
              style={{
                color: "#757575",
                fontSize: " 12px",
                fontWeight: "400",
              }}
            >
              {
                "Please select a reason from below. It will help us improve AI summary"
              }
            </span>
          </div>
          <div className="pl-1 pr-1">{modalBody(reasonDeatils)}</div>
        </DraggableModal>
      )}
      <div className="h-100 w-100 insightContainerDiv">
        <div className="commentDropdownDivDK">
          <Typography
            variant={["xxl", "xl", "lg"].includes(screen) ? "h6" : "h6"}
            color="black"
          >
            <AIIcon />
            &nbsp;Student Insights
            <span className="textGradient">Beta</span>
          </Typography>
          {!studentInsightLoading &&
          studentInsight &&
          studentInsight?.studentInsights &&
          studentInsight["studentInsights"] != null ? (
            <div className="d-flex flex-row gap-3">
              <Paragraph
                copyable={{
                  icon: [<CopyIcon key={12}></CopyIcon>],
                  text: studentInsight["studentInsights"],
                }}
              ></Paragraph>
              {viewAllComments ? (
                <span
                  onClick={() => {
                    setViewAllComments(!viewAllComments);
                  }}
                  className="filterSpan ml-2"
                >
                  {viewAllComments ? "Close" : ""}
                </span>
              ) : null}
            </div>
          ) : null}
        </div>
        {studentInsightLoading ? (
          <div className="w-100 p-3 insightContainerDiv d-flex flex-column justify-content-center align-items-center">
            <Spinner color="info"></Spinner>
          </div>
        ) : studentInsight &&
          studentInsight["studentInsights"] &&
          studentInsight["studentInsights"] != null ? (
          <div className="d-flex flex-column justify-content-between">
            {studentInsight.persisted ? (
              <div
                className="insightContainerMain5"
                dangerouslySetInnerHTML={{
                  __html: formatText(studentInsight["studentInsights"]).join(
                    ""
                  ),
                }}
              />
            ) : (
              <div>
                <APITypingResponse
                  response={studentInsight["studentInsights"]}
                  isComplete={isComplete}
                  setIsComplete={setIsComplete}
                />
              </div>
            )}
            {showPopoverFeedback || feedbackType != undefined ? (
              <div className="feedback-container feedback-container-success">
                <div className="d-flex flex-row align-items-center gap-3">
                  {" "}
                  {feedbackType == "liked" ? (
                    <ThumbsUpIcon color={"#07794C"} />
                  ) : (
                    <ThumbsDownIcon color={"#B32306"} />
                  )}
                  <Typography variant="subheading3" color="darkgray">
                    Feedback taken. It will help in improving AI summary
                  </Typography>
                </div>
              </div>
            ) : (
              <>
                {isComplete && (
                  <div className="feedback-container">
                    <div>
                      <Typography variant="subheading3" color="gray">
                        Did you find insights useful?
                      </Typography>
                    </div>
                    <div className="d-flex flex-row align-items-center gap-3">
                      <div className="postiveFeedbackDiv">
                        <ThumbsUpIcon
                          className="cursor-pointer"
                          onClick={() => {
                            if (feedbackType == undefined) {
                              handleInsightLike();
                            }
                          }}
                          color={
                            feedbackType == "liked"
                              ? "#07794C"
                              : feedbackType != undefined
                              ? "#AFAFAF"
                              : "#757575"
                          }
                        />
                      </div>
                      <div className="negativeFeedbackDiv">
                        <ThumbsDownIcon
                          className="cursor-pointer"
                          id="dislike-popover"
                          onClick={() => {
                            if (feedbackType == undefined) {
                              handleInsightDislike();
                            }
                          }}
                          color={
                            feedbackType == "disliked"
                              ? "#B32306"
                              : feedbackType != undefined
                              ? "#AFAFAF"
                              : "#757575"
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        ) : studentInsightError && studentInsightError != null ? (
          <div className="w-100 insightContainerDiv d-flex flex-column justify-content-between align-items-center">
            <div className="px-6 py-3">
              <Typography
                variant={
                  ["xxl", "xl", "lg"].includes(screen) ? "body2" : "body2"
                }
                color="black"
              >
                {studentInsightError}
              </Typography>
            </div>
            <Button
              className="BtnStudentInsight BtnStudentInsight-purple"
              onClick={() => {
                handleGenerateinsights();
              }}
            >
              <AIIcon />
              <span className="btntextGradient">
                Re-Generate Student Insight
              </span>
            </Button>
          </div>
        ) : (
          <div className="w-100 insightContainerDiv d-flex flex-column justify-content-between align-items-center">
            <div className="px-6 py-3">
              <Typography
                variant={
                  ["xxl", "xl", "lg"].includes(screen) ? "body2" : "body2"
                }
                color="black"
              >
                Your insights are powered by AI, so mistakes are possible
              </Typography>
            </div>
            <Button
              className="BtnStudentInsight BtnStudentInsight-purple"
              onClick={() => {
                handleGenerateinsights();
              }}
            >
              <AIIcon />
              <span className="btntextGradient">Generate Student Insight</span>
            </Button>
          </div>
        )}
      </div>
    </>
  );
}

export const formatText = (text: any) => {
  const lines = text.split("\n");
  const formattedLines = lines.map((line: any, index: any) => {
    if (line.includes(":")) {
      const [heading, ...rest] = line.split(":");
      return `<div style={{ lineHeight: 28px !important}} key=${index}><strong style={{fontWeight: 600,
          color: #333333}}>${heading}:</strong> ${rest.join(":").trim()}</div>`;
    } else {
      return `<div style={{fontWeight: 400;
          paddingLeft: 20px;
          color: #262626;}} key=${index}>${line.trim()}</div>`;
    }
  });
  return formattedLines;
};

const APITypingResponse = ({ response, setIsComplete }: any) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentCharIndex, setCurrentCharIndex] = useState(0);

  useEffect(() => {
    const text = formatText(response).join("");
    if (currentCharIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(text.slice(0, currentCharIndex + 1));
        setCurrentCharIndex(currentCharIndex + 1);
      }, 5); // Adjust typing speed here
      return () => clearTimeout(timeout);
    } else {
      setIsComplete(true);
    }
  }, [currentCharIndex, response]);
  return (
    <div
      className="insightContainerMain5"
      dangerouslySetInnerHTML={{ __html: displayedText }}
    />
  );
};
export default StudentInsightListing;
